<template>
<div class="chapter">
<div class="inner_page">
<p class="OT"><a id="page_vi"></a><a id="page_vii">Contents</a></p><a id="page_vii">
</a><p class="TocSb1" id="for"><a id="page_vii"></a><a href="#/xhtml/foreword#for"><i>Foreword</i> by Rowan Williams</a></p>
<p class="Toc1" id="pre"><a href="#/xhtml/preface#pre">Preface</a></p>
<p class="Toc" id="ch-001"><a href="#/xhtml/chapter001#ch001">1.<span class="space1">Jesus according to Jesus</span></a></p>
<p class="Toc" id="ch-002"><span href="#/xhtml/chapter002#ch002" title="Link target outside of Sample">2.<span class="space1">Jesus according to Mark, Matthew, and Luke</span></span></p>
<p class="Toc" id="ch-003"><span href="#/xhtml/chapter003#ch003" title="Link target outside of Sample">3.<span class="space1">Jesus according to John</span></span></p>
<p class="Toc" id="ch-004"><span href="#/xhtml/chapter004#ch004" title="Link target outside of Sample">4.<span class="space1">Jesus according to Acts</span></span></p>
<p class="Toc" id="ch-005"><span href="#/xhtml/chapter005#ch005" title="Link target outside of Sample">5.<span class="space1">Jesus according to Paul: Part 1</span></span></p>
<p class="Toc" id="ch-006"><span href="#/xhtml/chapter006#ch006" title="Link target outside of Sample">6.<span class="space1">Jesus according to Paul: Part 2</span></span></p>
<p class="Toc" id="ch-007"><span href="#/xhtml/chapter007#ch007" title="Link target outside of Sample">7.<span class="space1">Jesus according to Hebrews</span></span></p>
<p class="Toc" id="ch-008"><span href="#/xhtml/chapter008#ch008" title="Link target outside of Sample">8.<span class="space1">Jesus according to James, Peter, John, and Jude</span></span></p>
<p class="Toc" id="ch-009"><span href="#/xhtml/chapter009#ch009" title="Link target outside of Sample">9.<span class="space1">Jesus according to Revelation</span></span></p>
<p class="Toc1" id="pos"><span href="#/xhtml/postscript#pos" title="Link target outside of Sample">Postscript</span></p>
<p class="Toc1" id="ap-001"><span href="#/xhtml/appendix001#ap001" title="Link target outside of Sample">Appendix 1. The Probable Date and Place of Origin for Documents of the New Testament</span></p>
<p class="Toc1" id="ap-002"><span href="#/xhtml/appendix002#ap002" title="Link target outside of Sample">Appendix 2. The Life and Mission of Paul</span></p>
<p class="Toc1" id="bib"><a id="page_viii"></a><span href="#/xhtml/bibliography#bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="Toc1" id="idx-001"><span href="#/xhtml/index001#idx001" title="Link target outside of Sample">Index of Subjects</span></p>
<p class="Toc1" id="idx-002"><span href="#/xhtml/index002#idx002" title="Link target outside of Sample">Index of Scripture and Other Ancient Texts</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?80698d08